import './Footer.scss';

import * as React from 'react';
import { Link } from 'gatsby';

import * as Core from 'components/core';
import ContentWrapper from 'components/ContentWrapper';

export default function Footer() {
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://eocampaign1.com/form/073b23de-16ff-11ef-b8a2-b373bd560371.js';
    script.async = true;
    script.setAttribute('data-form', '073b23de-16ff-11ef-b8a2-b373bd560371');
    document.querySelector('.Footer-newsletter').appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <ContentWrapper>
      <footer className="Footer">
        <Core.PatternBorder width="100%" />
        <div className="Footer-content">
          <nav className="Footer-nav">
            <div>
              <div className="Footer-nav-link">
                <Link to="/videos">Videos</Link>
              </div>
              <div className="Footer-nav-link">
                <Link to="/guide/">Guide</Link>
              </div>
              <div className="Footer-nav-link">
                <Link to="/blog">Blog</Link>
              </div>
              <div className="Footer-nav-link">
                <Link to="/guide/about-xoxo">About XOXO</Link>
              </div>
            </div>
            <div>
              <div className="Footer-nav-link">
                <Link to="/guide/covid">COVID</Link>
              </div>
              <div className="Footer-nav-link">
                <Link to="/guide/conduct">Code of Conduct</Link>
              </div>
              <div className="Footer-nav-link">
                <Link to="/guide/accessibility">Accessibility</Link>
              </div>
              <div className="Footer-nav-link">
                <Link to="/guide/inclusion">Inclusion</Link>
              </div>
            </div>
            <div>
              <div className="Footer-nav-link">
                <a href="mailto:hi@xoxofest.com">hi@xoxofest.com</a>
              </div>
              <div className="Footer-nav-link">
                <a href="https://xoxo.zone/@xoxo">Mastodon</a>
              </div>
              <div className="Footer-nav-link">
                <a href="https://bsky.app/profile/xoxofest.com">Bluesky</a>
              </div>
              <div className="Footer-nav-link">
                <a href="https://www.threads.net/@xoxofest">Threads</a>
              </div>
            </div>
          </nav>
          <div className="Footer-newsletter">
            <p>
              Want to hear about major XOXO news and announcements first? Sign
              up for our notification list.
            </p>
            {/* Script will be dynamically added here */}
          </div>
        </div>
        <div className="Footer-content">
          <p>
            Fonts generously provided by our friends at <a href="https://www.futurefonts.xyz/">Future Fonts</a> — 
            <a href="https://www.futurefonts.xyz/loveletters/optic">Optic</a>, <a href="https://www.futurefonts.xyz/phantom-foundry/phantom-sans">Phantom Sans</a>, and <a href="https://www.futurefonts.xyz/jtd/enfilade">Enfilade</a>.
          </p>
        </div>
        <div className="Footer-archives">
          <div className="Footer-archives-label">XOXO</div>
          <div className="Footer-archives-link">
            <Link to="/2012">2012</Link>
          </div>
          <div className="Footer-archives-link">
            <Link to="/2013">2013</Link>
          </div>
          <div className="Footer-archives-link">
            <Link to="/2014">2014</Link>
          </div>
          <div className="Footer-archives-link">
            <Link to="/2015">2015</Link>
          </div>
          <div className="Footer-archives-link">
            <Link to="/2016">2016</Link>
          </div>
          <div className="Footer-archives-link">
            <Link to="/2018">2018</Link>
          </div>
          <div className="Footer-archives-link">
            <Link to="/2019">2019</Link>
          </div>
          <div className="Footer-archives-link">
            <Link to="/2024">2024</Link>
          </div>
        </div>
      </footer>
    </ContentWrapper>
  );
}
